import { Alert } from '@mui/material';
import { MailWarningIcon } from 'lucide-react';

import type { EmailSenderFragment } from '@graphql/__generated__/graphql';
import { useLocale } from '@shared/hooks/locale';

export const hasEmailSendingAccount = (
  sender: EmailSenderFragment | null | undefined,
) => (sender?.nylas_account.length ?? 0) > 0;

type EmailSenderStatusAlertProps = {
  sender: EmailSenderFragment | null | undefined;
};

export const EmailSenderStatusAlert: React.FC<EmailSenderStatusAlertProps> = ({
  sender,
}) => {
  const { t } = useLocale();

  if (sender == null || hasEmailSendingAccount(sender)) {
    return null;
  }

  return (
    <Alert
      icon={<MailWarningIcon />}
      severity="error"
      sx={{
        mb: 2,
        borderWidth: 1,
        borderStyle: 'solid',
        borderColor: 'error.main',
      }}
    >
      {t("This user can't send emails")}
    </Alert>
  );
};
